import { render, staticRenderFns } from "./PriorityDot.vue?vue&type=template&id=5c5ccf8a&scoped=true&"
import script from "./PriorityDot.vue?vue&type=script&lang=js&"
export * from "./PriorityDot.vue?vue&type=script&lang=js&"
import style0 from "./PriorityDot.vue?vue&type=style&index=0&id=5c5ccf8a&lang=sass&scoped=true&"
import style1 from "./PriorityDot.vue?vue&type=style&index=1&id=5c5ccf8a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ccf8a",
  null
  
)

export default component.exports